/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Remove_Team_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove \"{name}\" from this space?" |
*
* @param {Spaces_Remove_Team_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_remove_team_confirm_description = /** @type {((inputs: Spaces_Remove_Team_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Remove_Team_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich aus diesem Space entfernen?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove "${i?.name}" from this space?`)
});